export class RoleApplicationClaim {
    applicationClaimId: string;
    roleCode: string;
}


// WEBPACK FOOTER //
// ./src/app/models/roleApplicationClaim.ts